// react
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { css } from 'styled-components';

// components
import { Logo } from '@/components/atoms';
import AccountInfo from '@/components/molecules/AccountInfo/AccountInfo';

/**
 * NavBar displays the navigation bar.
 */
export const NavBar = ({
  role,
  name,
  fallback,
  toHome = '/',
  toAccountSettings,
  onSignOut,
  isMobile,
  avatarSrc,
}: NavBarProps) => {
  return (
    <NavBarContainer>
      <NavBarLeft>
        <HomeLink to={toHome}>
          <Logo size='sm' />
        </HomeLink>
      </NavBarLeft>

      <NavBarRight>
        <AccountInfo
          fallback={fallback}
          role={role}
          name={name}
          onSignOut={onSignOut}
          toAccountSettings={toAccountSettings}
          avatarSrc={avatarSrc}
        />
      </NavBarRight>
    </NavBarContainer>
  );
};

const HomeLink = styled(Link)`
  display: block;
  cursor: pointer;
  padding: ${(props) => props.theme.spacing[4]} 0;
`;

const NavBarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.color.illustration.eggBlue};
  background: ${(props) => props.theme.color.neutral[10]};
  padding: ${(props) => props.theme.spacing[8]}
    ${(props) => props.theme.spacing[12]};

  ${(props) =>
    props.theme.breakpoint.sm(css`
      padding: ${props.theme.spacing[16]} ${props.theme.spacing[36]};
    `)};
`;

const NavBarLeft = styled.div``;

const NavBarRight = styled.div``;

interface NavBarProps {
  role: string;
  name: string;
  fallback: string;
  toHome?: string;
  toAccountSettings?: string;
  onSignOut?: () => void;
  isMobile?: boolean;
  avatarSrc?: string;
}

NavBar.displayName = 'NavBar';

export default NavBar;
